module.exports = __webpack_public_path__ + "img/好评反馈图片.a61bad47.png";